export enum ReceiptFont {
  basic,
  condensed,
}